// 本模块为首页视图相关逻辑及状态,主要用来做页面传参
import recruit from "@/api/recruit.js";

const state = {
    wapRecruitsList: [],
    recruitsList: [],
    recruitsTotal: 1,
    recruitsLastPage: 1
};

const getters = {
    wapRecruitsList(state) {
        return state.wapRecruitsList;
    },
    recruitsList(state) {
        return state.recruitsList;
    },
    recruitsTotal(state) {
        return state.recruitsTotal;
    },
    recruitsLastPage(state) {
        return state.recruitsLastPage;
    }
};

const mutations = {
    setRecruitsState(state, { key, value }) {
        state[key] = value;
    }
};

const actions = {
    getRecruitsList({ state, dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            recruit
                .recruits({
                    per_page: data.per_page,
                    page: data.page,
                    job_name: data.job_name,
                    salary_requirement: data.salary_requirement,
                    experience: data.experience,
                    education: data.education,
                    province_id: data.province_id,
                    city_id: data.city_id
                })
                .then(res => {
                    let code = res.data.code;
                    if (code == 200) {
                        commit("setRecruitsState", {
                            key: "recruitsList",
                            value: res.data.data.data
                        });
                        commit("setRecruitsState", {
                            key: "recruitsTotal",
                            value: res.data.data.total
                        });
                        commit("setRecruitsState", {
                            key: "recruitsLastPage",
                            value: res.data.data.last_page
                        });
                        let list = [];
                        if (data.page === 1) {
                            list = res.data.data.data;
                        } else {
                            list = state.wapRecruitsList.concat(res.data.data.data);
                        }
                        commit("setRecruitsState", {
                            key: "wapRecruitsList",
                            value: list
                        });
                        resolve(res);
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};
export default {
    state,
    getters,
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/recruit.js